import { RECEIVED_ACCOUNTS } from '../account/AccountBalancesActions';
import { cloneDeep, merge } from 'lodash';
import { PREFILTER_ACCOUNTS } from '../Actions';
import {
  isActiveAdvisory,
  isActivePlus,
  isBrokerage,
  isCollegeSavings,
  isMutualFund,
  isRetirementAccount,
  isViewOnlyAccount,
  isRelatedAccount,
  isOwnedAccount
} from 'services/Products';
import { RECEIVED_CUSTOM_ACCOUNT_GROUPS } from 'state/preferences/PreferencesActions';
import {
  AccountTypeOptions,
  ALL_LABEL,
  APP_LABEL,
  BROKERAGE_LABEL,
  COLLEGE_SAVINGS_LABEL,
  MUTUAL_FUND_LABEL,
  NON_RETIREMENT_LABEL,
  OWNED_LABEL,
  RAS_LABEL,
  RELATED_LABEL,
  RETIREMENT_LABEL,
  VIEW_ONLY_LABEL
} from 'services/Filters';

const filterForAll = (accounts) => accounts;
const filterForActiveAdvisory = (accounts) =>
  accounts.filter((a) => isActiveAdvisory(a.productType));
const filterForActivePlus = (accounts) =>
  accounts.filter((a) => isActivePlus(a.productType));
const filterForMutualFunds = (accounts) =>
  accounts.filter((a) => isMutualFund(a.productType));
const filterForBrokerage = (accounts) =>
  accounts.filter((a) => isBrokerage(a.productType));
const filterForCollegeSavings = (accounts) =>
  accounts.filter((a) => isCollegeSavings(a.productType));
const filterForRetirement = (accounts) =>
  accounts.filter((a) => isRetirementAccount(a));
const filterForNonRetirement = (accounts) =>
  accounts.filter((a) => !isRetirementAccount(a));
const filterForOwned = (accounts) => accounts.filter((a) => isOwnedAccount(a));
const filterForRelated = (accounts) =>
  accounts.filter((a) => isRelatedAccount(a));
const filterForViewOnly = (accounts) =>
  accounts.filter((a) => isViewOnlyAccount(a));

// for unit tests
export const getFilterFunctionForAccountType = {
  [ALL_LABEL]: filterForAll,
  [RAS_LABEL]: filterForActiveAdvisory,
  [APP_LABEL]: filterForActivePlus,
  [MUTUAL_FUND_LABEL]: filterForMutualFunds,
  [BROKERAGE_LABEL]: filterForBrokerage,
  [COLLEGE_SAVINGS_LABEL]: filterForCollegeSavings,
  [RETIREMENT_LABEL]: filterForRetirement,
  [NON_RETIREMENT_LABEL]: filterForNonRetirement,
  [OWNED_LABEL]: filterForOwned,
  [RELATED_LABEL]: filterForRelated,
  [VIEW_ONLY_LABEL]: filterForViewOnly
};

// Sort accounts into specific categories
export const sortAccountIdsByType = (accounts) =>
  AccountTypeOptions.reduce((reducer, { label }) => {
    const filter = getFilterFunctionForAccountType[label];
    return {
      ...reducer,
      [label]: filter(accounts).map((a) => a.accountId)
    };
  }, {});

const updatePerformancePage = (state, action) => {
  const performancePage = cloneDeep(state);
  performancePage.accountIdsByType = sortAccountIdsByType(action.accounts);

  return performancePage;
};

// For custom account groups
const updatePerformancePageWithCustomGroups = (
  state,
  { customAccountGroups }
) => {
  const performancePage = cloneDeep(state);
  let customAccountGroupIdsByName = {};

  if (customAccountGroups && customAccountGroups.length > 0) {
    customAccountGroups.forEach(
      (group) => (customAccountGroupIdsByName[group.name] = group.accountIds)
    );
  }

  performancePage.accountIdsByType = merge(
    performancePage.accountIdsByType,
    customAccountGroupIdsByName
  );
  return performancePage;
};

export const PerformancePageReducer = (state, action) => {
  switch (action.type) {
    case RECEIVED_ACCOUNTS:
    case PREFILTER_ACCOUNTS:
      return updatePerformancePage(state, action);
    case RECEIVED_CUSTOM_ACCOUNT_GROUPS:
      return updatePerformancePageWithCustomGroups(state, action);
    default:
      return state;
  }
};
